import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { attachScript } from '../../../common/utils/attach-script';
import { URL } from '../../../common/utils/url';
import styles from './styles.scss';
const scriptApiUrl = 'https://www.youtube.com/iframe_api';
let apiPromise = null;
export class Youtube extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleIframeRef", ref => {
      if (!ref) {
        return;
      }
      this.iframeRef = ref;
      // TODO: replace with setting 'allow' attribute in jsx after migration to React 16
      ref.setAttribute('allow', 'autoplay');
      // if src is set before allow="autoplay", 'allow' has no effect
      ref.setAttribute('src', this.buildUrl(this.props));
      this.props.onIframeRef(ref);
    });
    _defineProperty(this, "onYouTubeIframeAPIReady", () => {
      new window.YT.Player(this.iframeRef, {
        events: {
          onReady: this.onReady,
          onStateChange: this.onStateChange
        }
      });
    });
    _defineProperty(this, "onReady", _ref => {
      let {
        target
      } = _ref;
      this.player = target;
      this.setState({
        isReady: true
      });
      this.setSettings(this.props);
    });
    _defineProperty(this, "onStateChange", _ref2 => {
      let {
        data
      } = _ref2;
      const {
        onPlay,
        onPause,
        onEnd
      } = this.props;
      switch (data) {
        case window.YT.PlayerState.PLAYING:
          onPlay();
          break;
        case window.YT.PlayerState.PAUSED:
          onPause();
          break;
        case window.YT.PlayerState.ENDED:
          onEnd();
          break;
        default:
          break;
      }
    });
    _defineProperty(this, "onIframeLoaded", async () => {
      if (!apiPromise) {
        apiPromise = Promise.race([new Promise(resolve => {
          window.onYouTubeIframeAPIReady = resolve;
        }), new Promise(resolve => {
          if (window.YT) {
            // somebody else already loaded api
            window.YT.ready(resolve);
          }
        })]);
        attachScript(scriptApiUrl);
      }
      await apiPromise;
      this.onYouTubeIframeAPIReady();
    });
    this.player = null;
    this.iframeRef = null;
    this.state = {
      isReady: false
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.src === this.props.src) {
      this.setSettings(nextProps, this.props);
    } else {
      this.setState({
        isReady: false
      });
    }
  }
  setSettings(_ref3, prevProps) {
    let {
      isVideoPlayRequested,
      isVideoPauseRequested,
      loop,
      muted
    } = _ref3;
    if (prevProps === void 0) {
      prevProps = {};
    }
    if (!this.player || !this.state.isReady) {
      return null;
    }
    if (prevProps.muted !== muted) {
      this.toggleMute(muted);
    }
    if (prevProps.isVideoPlayRequested !== isVideoPlayRequested && isVideoPlayRequested) {
      this.togglePaused(false);
    }
    if (prevProps.isVideoPauseRequested !== isVideoPauseRequested && isVideoPauseRequested) {
      this.togglePaused(true);
    }
    this.toggleLoop(loop);
  }
  togglePaused(paused) {
    if (paused) {
      this.player.pauseVideo();
    } else {
      this.player.playVideo();
    }
  }
  toggleLoop(loop) {
    if (loop) {
      const {
        video_id
      } = this.player.getVideoData();
      // need load playlist to set loop to true
      // but loadPlay list sets video to the beginning
      this.player.loadPlaylist(video_id);
      this.player.setLoop(true);
    } else {
      this.player.setLoop(false);
    }
  }
  toggleMute(muted) {
    if (muted) {
      this.player.mute();
    } else {
      this.player.unMute();
    }
  }
  buildUrl(_ref4) {
    let {
      src,
      mobileMode,
      showControls,
      locale
    } = _ref4;
    const {
      protocol,
      hostname,
      port
    } = window.location;
    const origin = protocol + "//" + hostname + (port ? ':' : '') + port;
    const query = {
      enablejsapi: '1',
      hl: locale,
      rel: '0',
      origin
    };
    if (mobileMode) {
      query.playsinline = '1';
    }
    if (!showControls) {
      query.controls = '0';
    }
    const url = new URL(src);
    // https is required for autoplay
    url.protocol = 'https';
    url.search = query;
    return url.toString();
  }
  render() {
    const {
      className,
      width,
      height,
      isVideoPauseRequested,
      isVideoPlayRequested,
      isVideoPlaying,
      isVideoPaused,
      fillAllSpace
    } = this.props;
    const tabIndex = isVideoPauseRequested || isVideoPlayRequested || isVideoPlaying || isVideoPaused ? 0 : -1;
    return /*#__PURE__*/React.createElement("iframe", {
      title: "Youtube",
      width: width,
      height: height,
      frameBorder: "0",
      allowFullScreen: true,
      tabIndex: tabIndex,
      onLoad: this.onIframeLoaded,
      ref: this.handleIframeRef,
      className: classNames(styles.iframe, className, {
        [styles.fillAllSpace]: fillAllSpace
      })
    });
  }
}
//# sourceMappingURL=youtube.js.map